import constants from "./CONSTANTS";

const actions = {
  blobDownload: (id) => ({
    type: constants.SET_UNO_BLOB_DOWNLOAD,
    id,
  }),

  setCallRequestHasBeenSent: (payload) => ({
    type: constants.SET_CALL_REQUEST_HAS_BEEN_SENT,
    payload,
  }),

  getSendCallRequest: (payload) => ({
    type: constants.GET_SEND_CALL_REQUEST,
    payload,
  }),

  getServiceToken: () => ({
    type: constants.GET_SERVICE_TOKEN,
  }),
  setServiceToken: (payload) => ({
    type: constants.SET_SERVICE_TOKEN,
    payload,
  }),
  setCallRequestLoading: (payload) => ({
    type: constants.SET_CALL_REQUEST_LOADING,
    payload,
  }),
};

export default actions;
